/* import __COLOCATED_TEMPLATE__ from './deactivate-confirmation.hbs'; */
import Component from '@glimmer/component';
export default class DeactivateConfirmation extends Component {}